import React, {FC} from 'react';

import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {TeamAvatar} from '../../../components/common/avatars/teamAvatar';
import {TeamModel} from '../../../models/api/teamModel';
import {SettingsSearchDropdownTitleAccessory} from './settingsSearchCommon';

/*
 * Props.
 */

interface SettingsSearchDropdownTeamAccessoryProps {
  team: TeamModel;
}

/*
 * Component.
 */

export const SettingsSearchDropdownTeamAccessory: FC<SettingsSearchDropdownTeamAccessoryProps> = (props) => (
  <SettingsSearchDropdownTitleAccessory>
    <TeamAvatar size={VisualSizesEnum.SMALL} team={props.team} />
  </SettingsSearchDropdownTitleAccessory>
);
